import { Component, Input, OnInit } from '@angular/core';
import { Accommodation } from '@generated/graphql';
import { TripsItineraryAccommodationItemComponent } from '../trips-itinerary-accommodation-item/trips-itinerary-accommodation-item.component';

@Component({
    selector: 'app-trips-itinerary-accommodation',
    templateUrl: './trips-itinerary-accommodation.component.html',
    imports: [TripsItineraryAccommodationItemComponent],
})
export class TripsItineraryAccommodationComponent implements OnInit {
    @Input() accommodations: Accommodation[];

    constructor() {}

    ngOnInit(): void {}
}
